import localization from "../statics/localization";

export const finiteNonNegative = value => {
  if ((typeof value !== "number" && typeof value !== "string") || String(value).trim() === "") return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};

export const recordingDate = value => {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null;
  if (typeof value !== "string" && typeof value !== "number") return null;
  const match = typeof value === "string" && value.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/);
  if (match) {
    const [, day, month, year, hour, minute, second = "00"] = match;
    const time = Date.UTC(+year, +month - 1, +day, +hour, +minute, +second);
    const check = new Date(time);
    if (check.getUTCFullYear() !== +year || check.getUTCMonth() !== +month - 1 ||
        check.getUTCDate() !== +day || check.getUTCHours() !== +hour ||
        check.getUTCMinutes() !== +minute || check.getUTCSeconds() !== +second) return null;
    // MW EPG dates are Europe/Istanbul wall time, independent of the browser zone.
    return new Date(time - 3 * 60 * 60 * 1000);
  }
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
};

export const recordState = item => {
  const explicit = String(item?.Status ?? item?.status ?? "").toUpperCase();
  const aliases = { RECORDED: "READY", IN_PROGRESS: "RECORDING" };
  if (explicit) return aliases[explicit] || (["READY", "SCHEDULED", "PENDING", "RECORDING", "PROCESSING", "FAILED", "EXPIRED"].includes(explicit) ? explicit : "UNKNOWN");
  const legacy = { "1": "READY", "999": "RECORDING", "0": "SCHEDULED", "-1": "FAILED", "-3": "EXPIRED" };
  if (item?.newstatus !== undefined) return legacy[String(item.newstatus)] || "UNKNOWN";
  if (item?.IsCompleted === true || item?.isCompleted === true) return "READY";
  if (item?.IsInProgress === true || item?.isInProgress === true) return "RECORDING";
  if (item?.IsCompleted === false || item?.isCompleted === false) return "PENDING";
  return "UNKNOWN";
};

export const recordStateLabel = item => localization.recordingStatuses[recordState(item).toLowerCase()];
export const playableRecord = item => recordState(item) === "READY" && item?.HasVod !== false && item?.hasVod !== false;

export const recordDateLabel = value => {
  const date = recordingDate(value);
  return date ? date.toLocaleString(localization.getLanguage() || "en", { timeZone: "Europe/Istanbul", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";
};

export const quotaDisplay = data => {
  const used = finiteNonNegative(data?.usedQuota);
  const total = finiteNonNegative(data?.NpvrQuota);
  const remaining = finiteNonNegative(data?.quotaLeft);
  if (data?.isLimitless === true) {
    if (used === null) throw new Error("Recording usage unavailable");
    return { used, remaining: null, percentage: 0, isLimitless: true };
  }
  if (total === null || remaining === null) throw new Error("Recording quota unavailable");
  const safeRemaining = Math.min(total, remaining);
  return { used: used ?? Math.max(0, total - safeRemaining), remaining: safeRemaining,
    percentage: total > 0 ? Math.min(100, Math.max(0, (total - safeRemaining) / total * 100)) : 0, isLimitless: false };
};
